import buildService from '../../helper/service'

// 值类型为String或Object,String为url(method),Object同axios(config)参数支持相同,data和params只能为对象类型
const settings = {
  //图片上传接口
  uploadFile: {
    url: '/adminc/v1/upload/upload_file_remote',
    method: 'post'
  },
  //获取单位类型下拉列表数据
  getCodeList: {
    url: '/adminc/v1/config_manage/b_code/get_code_list',
    method: 'get'
  },
  //获取省接口
  getProvince: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_list',
    method: 'get',
  },
  //获取市接口
  getCity: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_list',
    method: 'get',
  },
  //获取区接口
  getArea: {
    url: '/adminc/v1/organization_manage/b_area/get_area_box_list',
    method: 'get',
  },
  //获取证件类型
  getCard: {
    url: '/adminc/v1/config_manage/b_code/get_code_list',
    method: 'get',
  },
  //修改单位
  sureeditUnit: {
    url: "/adminc/v1/organ/organ_manage/update_company",
    method: 'put',
  },
  //获取详情信息
  getDetail: {
    url: "/adminc/v1/organ/organ_manage/get_comp_detail",
    method: 'get',
  }
}
export default buildService(settings)



// WEBPACK FOOTER //
// ./src/services/orgainzeManage/editUnit.js